<template>
  <v-container fluid class="fade-in mx-5">
    <v-row>
      <v-col xs="12" center class="pt-2 pb-0">
        <h1>Search Support Request</h1>
				<v-layout data-app wrap row>
            <v-flex xs12 class="horiz-margin-20">
              <!--Model popup window to add Office-->
              <div>
                <b-modal size="xl"  ref="my-modal" hide-footer v-model="addSupportRequest.addorupdateflag" :title="heading" :no-close-on-backdrop="true" :no-close-on-esc="true">
                  <div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <b-container fluid>
                        <b-row class="mb-1">
                          <b-col cols="3">Agency <span style="color:red">*</span></b-col>
                          <b-col>
														<select v-model="addSupportRequest.agency" class="form-control" :disabled="disableFlag" @change="onChangeAgency($event)">
                              <option value="null" selected>Select</option>
                              <option v-for="ag in filterItems.agencies" :value="ag.code" :key="ag.code">{{ ag.code }}</option>
                            </select>
														<span style="color:red">{{ agencyTypeRule }}</span>
                          </b-col>
													<b-col cols="3">Program </b-col>
                          <b-col>
                            <select v-model="addSupportRequest.program" class="form-control" :disabled="disableFlag" @change="onChangeProgram($event)">
                              <option value="null" selected>Select</option>
                              <option v-for="pg in filterItems.programs" :value="pg.code" :key="pg.code">{{ pg.code }}</option>
                            </select>
                          </b-col>
                        </b-row>
												<b-row class="mb-1">
													<b-col cols="3">Field </b-col>
                          <b-col>
                            <select v-model="addSupportRequest.field" class="form-control" :disabled="disableFlag" @change="onChangeField($event)">
                              <option value="null" selected>Select</option>
                              <option v-for="field in filterItems.fields" :value="field.code" :key="field.code">{{ field.code }}</option>
                            </select>
                          </b-col>
													<b-col cols="3">Branch </b-col>
                          <b-col>
                            <select v-model="addSupportRequest.branch" class="form-control" :disabled="disableFlag" @change="onChangeBranch($event)">
                              <option value="null" selected>Select</option>
                              <option v-for="branch in filterItems.branches" :value="branch.code" :key="branch.code">{{ branch.code }}</option>
                            </select>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Department </b-col>
                          <b-col>
														<span>{{ addSupportRequest.department }}</span>
                          </b-col>
                          <b-col cols="3">Office Name </b-col>
                          <b-col>
                            <span>{{ addSupportRequest.officeName }}</span>&nbsp;<!--<span style="visibility:false">{{ addSupportRequest.officeId }}</span>-->
                          </b-col>
                        </b-row>
												<b-row class="mb-1">
                          <b-col cols="3">User Id </b-col>
                          <b-col>
                            <span>{{ addSupportRequest.userId }}</span>
                          </b-col>
                        </b-row>
                        <b-row style="width:100%;background-color:skyblue">
                          <div>Contact Details:</div>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">First Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addSupportRequest.firstName" maxlength="100" label="First Name" required :rules="firstNameRule" :disabled="disableFlag"></v-text-field>
                          </b-col>
                          <b-col cols="3">Last Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addSupportRequest.lastName" maxlength="100" label="Last Name" required :rules="lastNameRule" :disabled="disableFlag"></v-text-field>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
													<b-col cols="3">Title</b-col>
                          <b-col>
                            <input v-model="addSupportRequest.title" type="text" class="form-control" name ="title" :disabled="disableFlag" maxlength="200"/>
                          </b-col>
													<b-col cols="3">Phone <span style="color:red">*</span></b-col>
                          <b-col>
														<v-text-field v-model="addSupportRequest.phone" maxlength="12" label="Phone" required :rules="phone" :disabled="disableFlag"></v-text-field>
                          </b-col>
                        </b-row>
                         <b-row class="mb-1">
                          <b-col cols="3">E-mail</b-col>
                          <b-col>
                            <v-text-field v-model="addSupportRequest.email" maxlength="200" label="E-mail" required :rules="emailRule" :disabled="disableFlag" style="width:500px"></v-text-field>
                          </b-col>
                        </b-row>
												<b-row style="width:100%;background-color:skyblue">
                          <div>Support Request Details:</div>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Problem Type <span style="color:red">*</span></b-col>
                          <b-col>
                            <select v-model="addSupportRequest.topicType" class="form-control">
                              <option value="" selected>Select</option>
                              <option v-for="problemType in addSupportRequest.problemTypes" :value="problemType.id" :key="problemType.id">{{ problemType.text }}</option>
                            </select>
														<span style="color:red">{{ problemTypeRule }}</span>
                          </b-col>
                          <b-col cols="3">Contact Person</b-col>
                          <b-col>
                            <input v-model="addSupportRequest.contactPerson" maxlength="100" type="text" class="form-control" name ="contactPerson" />
                          </b-col>
                        </b-row>
												<b-row class="mb-1">
                          <b-col cols="3">Assigned To</b-col>
                          <b-col>
                            <input v-model="addSupportRequest.assignedTo" maxlength="100" type="text" class="form-control" name ="assignedTo"/>
                          </b-col>
													<b-col cols="3">Tested By</b-col>
                          <b-col>
                            <input v-model="addSupportRequest.testedBy" maxlength="100" type="text" class="form-control" name ="testedBy" />
                          </b-col>
                        </b-row>
												<b-row class="mb-1">
                          <b-col cols="3">Contact Type <span style="color:red">*</span></b-col>
                          <b-col>
                            <select style="width:200px" v-model="addSupportRequest.contactType" class="form-control" required :rules="contactTypeRule">
                              <option value="" selected> Select </option>
															<option value="1"> Email </option>
															<option value="2"> Phone </option>
															<option value="3"> Other </option>
                            </select>
														<span style="color:red">{{ contactTypeRule }}</span>
                          </b-col>
                        </b-row>
												<b-row class="mb-1">
													<b-col cols="3">Follow up e-mail contact count</b-col>
													  <b-col><input style="width:100px" v-model="addSupportRequest.contactEmailCount" type="number" onKeyPress="if(this.value.length==2) return false;" maxlength="2" class="form-control"  name ="contactEmailCount"/></b-col>
                        </b-row>
												<b-row class="mb-1">
                          <b-col cols="3">Follow up phone contact count</b-col>
                          <b-col><input style="width:100px" v-model="addSupportRequest.contactPhoneCount" type="number" onKeyPress="if(this.value.length==2) return false;" maxlength="2" class="form-control"  name ="contactPhoneCount"/></b-col>
                        </b-row>
												<b-row class="mb-1">
                          <b-col cols="3">Follow up other contact count</b-col>
                          <b-col><input style="width:100px" v-model="addSupportRequest.contactOtherCount" type="number" onKeyPress="if(this.value.length==2) return false;" maxlength="2" class="form-control" name ="contactOtherCount"/></b-col>
                        </b-row>
												<b-row class="mb-1">
                          <b-col cols="3">Request Status</b-col>
                          <b-col>
													<select style="width:100px" v-model="addSupportRequest.requestStatus" class="form-control">
															<option value="1" selected> Open </option>
															<option value="2"> Closed </option>
													</select>
                  			</b-col>
                        </b-row>
												<b-row>
                          <b-col cols="3">Description</b-col>
                          <b-col>
                            <textarea v-model="addSupportRequest.description" rows="5" cols="60" placeholder="Enter text" class="form-control" name="description" :min-height="200"
														:max-height="400"></textarea>
                          </b-col>
                        </b-row>
                      </b-container>
                      <b-button class="form-button" :loading="isLoading" v-model="heading" block @click="onSave(heading, addSupportRequest.id)">Save</b-button>&nbsp;<span style="color:blue;">{{message}}</span>
                    </v-form>
                   </div>
                </b-modal>
              </div>
            </v-flex>
          </v-layout>
      </v-col>
    </v-row>

    <!-- wrap  -->
    <v-row data-app wrap class="search-ctrls elevation-3">
      <v-col sm="10" md="10">
        <v-text-field
          v-model="request"
          hide-details="false"
          placeholder="Search for request by first name, last name, email, agency, program, field, branch, contact person, email, phone or assigned to"
          @keypress="onKeyUp"
        ></v-text-field>
      </v-col>
      <v-col sm="10" md="2" class="d-flex align-end">
           <v-btn color="primary" dark @click="onSearchClicked(request,false)">Search</v-btn>
					 &nbsp;<span style="color:blue;">{{processing}}</span>&nbsp;
      </v-col>
    </v-row>

    <v-layout data-app wrap row>
      <v-flex xs12>
				<v-data-table :headers="headers"
                :items="rowData"
                item-key="id"
                class="elevation-3" :loading="isLoading" loading-text="Loading... Please wait">
								<template #item.id = {value} >
              				<a href="#" @click="onAddNewRequest(value,true);">View</a>
           				</template>
                </v-data-table>
      </v-flex>
    </v-layout>
			<v-layout data-app wrap row>
							<v-flex xs12 class="horiz-margin-20">
								<div class="buttons">&nbsp;<span style="color:blue;">{{processing}}</span>
									<v-btn normal class="form-button" @click="onAddNewRequest(addSupportRequest.id,false)">Create New Request</v-btn>
								</div>
							</v-flex>
						</v-layout>
  </v-container>
</template>

<script>

import { officeManagementService } from '@/services/officeManagementService.js';
import { userService } from "@/services/userService.js";
import moment from 'moment';

export default {
  name: "SupportRequest",
  data: () => ({
    headers: [
      { text: "Click View to edit the information", value: "id", class: 'cellLink' },
			{ text: "Office name", value: "officeName" },
      { text: "First name", value: "firstName" },
      { text: "Last Name", value: "lastName" },
      { text: "Title", value: "title" },
      { text: "Phone", value: "phone" },
      { text: "E-mail", value: "email" },
      { text: "TopicType", value: "text" },
      { text: "Contact Person", value: "contactPerson" },
      { text: "Assigned To", value: "assignedTo" },
      { text: "Tested By", value: "testedBy" },
      { text: "Contact Type", value: "cType" },
			{ text: "Department", value: "department" },
      { text: "Agency", value: "agency" },
      { text: "Program", value: "program" },
      { text: "Field", value: "field" },
      { text: "Branch", value: "branch" },
			{ text: "UserId", value: "userId" },
			{ text: "Request Status", value: "status" },
			{ text: "Created Date", value: "createDate" },
      { text: "Updated Date", value: "updateDate" }
    ],
    rowData: [],
		emailRule: [v => /.+@.+/.test(v) || "E-mail must be valid"],
		firstNameRule: [v => !!v || 'First Name is required'],
		lastNameRule: [v => !!v || 'Last Name is required'],
		phoneRule: [v => !!v || 'Phone number is required'],
		phone: [ v => /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(v) || "Must be a valid phone number" ],
		contactTypeRule: "",
		problemTypeRule: "",
		agencyTypeRule: "",
    request: null,
		processing: '',
		message: '',
		heading: null,
		isLoading: true,
		flag: true,
		disableFlag: false,
		addSupportRequest: {
			id: 0,
			agency: null,
			program: null,
			field: null,
			branch: null,
			department: null,
			officeName: null,
			officeId: null,
			userId: null,
			firstName: null,
			lastName: null,
			title: null,
			phone: null,
			email: null,
			contactPerson: null,
			assignedTo: null,
			testedBy: null,
			contactType: "",
			contactEmailCount: 0,
			contactPhoneCount: 0,
			contactOtherCount: 0,
			requestStatus: 1,
			description: null,
			selectSurveyType: null,
			topicType: "",
			problemTypes: [],
			addorupdateflag: null,
			flag: Boolean
		},
		filterItems: {
				agencies: [],
				programs: [],
				fields: [],
				branches: []
			}
  }),
	mounted () {
		this.isLoading = false;
		this.OnLoad(this.request, false);
	},
  methods: {
    onKeyUp: function (evt) {
      if (evt.key === "Enter") {
        this.onSearchClicked(this.request, this.flag);
      }
    },
		onSave (heading, id) {
      const me = this;
			me.flag = false;
			me.message = "Processing please wait..";
			if (me.addSupportRequest.agency === null) {
				me.agencyTypeRule = "Agency Type is required";
				me.message = "";
				me.flag = true;
				} else {
					me.agencyTypeRule = "";
				}
				if (me.addSupportRequest.topicType === "") {
					me.problemTypeRule = "Problem Type is required";
					me.message = "";
					me.flag = true;
				} else {
					me.problemTypeRule = "";
				}
				if (me.addSupportRequest.contactType === "") {
					me.contactTypeRule = "Contact Type is required";
					me.message = "";
					me.flag = true;
				} else {
					me.contactTypeRule = "";
				}

				if (heading === "Add New Support Request") {
							me.addSupportRequest.addorupdateflag = true;
							me.addSupportRequest.id = 0;
							me.message = "";
				} else {
							me.addSupportRequest.addorupdateflag = false;
							me.addSupportRequest.id = id;
				}
        if (me.$refs.form.validate()) {
          me.isLoading = true;
					officeManagementService.saveSupportRequest(me.addSupportRequest.id, me.addSupportRequest.agency, me.addSupportRequest.program, me.addSupportRequest.field, me.addSupportRequest.branch,
													me.addSupportRequest.officeName, me.addSupportRequest.officeId, me.addSupportRequest.userId, me.addSupportRequest.firstName,
													me.addSupportRequest.lastName, me.addSupportRequest.title, me.addSupportRequest.phone, me.addSupportRequest.email,
													me.addSupportRequest.contactPerson, me.addSupportRequest.assignedTo, me.addSupportRequest.testedBy, me.addSupportRequest.contactType,
													me.addSupportRequest.contactEmailCount, me.addSupportRequest.contactPhoneCount, me.addSupportRequest.contactOtherCount, me.addSupportRequest.requestStatus,
													me.addSupportRequest.description, me.addSupportRequest.topicType, me.addSupportRequest.department, me.addSupportRequest.problemTypes, me.addSupportRequest.addorupdateflag)
              .then(function (response) {
                  if (response.data === "Successfully saved") {
                    me.isLoading = false;
                    me.message = response.data;
										me.processing = response.data;
                    me.offices = [];
                    setTimeout(() => { me.OnLoad(null, false); me.$refs['my-modal'].hide(); }, 2000);
										setTimeout(() => { me.processing = response.data; }, 3000);
									} else {
                    me.isLoading = false;
                    me.message = response.data;
                  }
              })
              .catch(function (response) {
								me.message = response;
                me.isLoading = false;
              });
				}
		},
		OnLoad (request, flag) {
			const me = this;
			me.isLoading = true;
			me.processing = "Processing please wait..";
      me.rowData = [];
      officeManagementService.getSupportRequest(request, flag)
            .then(function (response) {
							if (response && response.data) {
                    for (var i = 0; i < response.data.length; i++) {
                        me.rowData.push(response.data[i]);
                    }
                    me.processing = null;
										me.isLoading = false;
                }
            })
            .catch(function (err) {
								me.isLoading = false;
                console.error(err);
            });
		},
    onSearchClicked (request, flag) {
			if (request === "") {
				request = null;
			}
        this.OnLoad(request, flag);
    },
		onAddNewRequest (id, flag) {
          debugger;
          const me = this;
          me.addSupportRequest.addorupdateflag = flag;
          if (id != undefined && flag) {
              me.heading = "Update Support Request";
							me.message = '';
              officeManagementService.getSupportRequest(id, flag).then(function (response) {
              if (response && response.data) {
								me.addSupportRequest.id = response.data[0].id;
								me.disableFlag = true;
                me.addSupportRequest.agency = response.data[0].agency;
								me.addSupportRequest.program = response.data[0].program;
								me.addSupportRequest.field = response.data[0].field;
								me.addSupportRequest.branch = response.data[0].branch;
                me.addSupportRequest.officeName = response.data[0].officeName;
								me.addSupportRequest.officeId = response.data[0].officeId;
								if (response.data[0].program === null && response.data[0].field === null && response.data[0].branch === null) {
									me.addSupportRequest.userId = response.data[0].agency;
								}
								else if (response.data[0].program !== null && response.data[0].field === null && response.data[0].branch === null) {
									me.addSupportRequest.userId = response.data[0].agency + '-' + response.data[0].program;
								}
								else if (response.data[0].program !== null && response.data[0].field !== null && response.data[0].branch === null) {
									me.addSupportRequest.userId = response.data[0].agency + '-' + response.data[0].program + '-' + response.data[0].field;
								}
								else if (response.data[0].program !== null && response.data[0].field !== null && response.data[0].branch !== null) {
									me.addSupportRequest.userId = response.data[0].agency + '-' + response.data[0].program + '-' + response.data[0].field + '-' + response.data[0].branch;
								}
                me.addSupportRequest.firstName = response.data[0].firstName;
								me.addSupportRequest.lastName = response.data[0].lastName;
								me.addSupportRequest.title = response.data[0].title;
								me.addSupportRequest.phone = response.data[0].phone;
								me.addSupportRequest.email = response.data[0].email;
								me.addSupportRequest.contactPerson = response.data[0].contactPerson;
								me.addSupportRequest.assignedTo = response.data[0].assignedTo;
								me.addSupportRequest.testedBy = response.data[0].testedBy;
								me.addSupportRequest.contactType = response.data[0].contactType;
								me.addSupportRequest.contactEmailCount = response.data[0].contactEmailCount;
								me.addSupportRequest.contactPhoneCount = response.data[0].contactPhoneCount;
								me.addSupportRequest.contactOtherCount = response.data[0].contactOtherCount;
								me.addSupportRequest.requestStatus = response.data[0].requestStatus;
								me.addSupportRequest.description = response.data[0].description;
								me.addSupportRequest.topicType = response.data[0].topicType;
								me.addSupportRequest.department = response.data[0].department;
								var date = new Date(response.data[0].createDate);
								var str = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
								me.addSupportRequest.createDate = str;
								me.addSupportRequest.problemTypes = [];
								officeManagementService.getAllSupportTopics().then(function (response) {
									if (response && response.data) {
										for (var i = 0; i < response.data.length; i++) {
											me.addSupportRequest.problemTypes.push(response.data[i]);
										}
										if (me.addSupportRequest.problemTypes.length > 0) {
											for (var j = 0; j <= me.addSupportRequest.problemTypes.length; j++) {
												if (me.addSupportRequest.problemTypes[j].id === me.addSupportRequest.topicType) {
														break;
												}
											}
										}
									}
							});
							officeManagementService.getAllAgencyTrees().then(function (response) {
									me.filterItems.agencies = [];
									me.filterItems.programs = [];
									me.filterItems.fields = [];
									me.filterItems.branches = [];
										if (response && response.data.nodes) {
										for (var i = 0; i < response.data.nodes.length; i++) {
												me.filterItems.agencies.push(response.data.nodes[i]);
										}
										if (me.filterItems.agencies.length > 0) {
											for (var z = 0; z <= me.filterItems.agencies.length - 1; z++) {
												if (me.filterItems.agencies[z].code === me.addSupportRequest.agency) {
													if (me.filterItems.agencies[z].children !== null) {
														for (var j = 0; j < me.filterItems.agencies[z].children.length; j++) {
															me.filterItems.programs.push(me.filterItems.agencies[z].children[j]);
													}
													if (me.filterItems.programs.length > 0) {
														for (var u = 0; u <= me.filterItems.programs.length - 1; u++) {
															if (me.filterItems.programs[u].code === me.addSupportRequest.program) {
																for (var p = 0; p < me.filterItems.programs[u].children.length; p++) {
																			me.filterItems.fields.push(me.filterItems.programs[u].children[p]);
																}
																if (me.filterItems.fields.length > 0) {
																for (var f = 0; f <= me.filterItems.fields.length - 1; f++) {
																		if (me.filterItems.fields[f] !== undefined) {
																			if (me.filterItems.fields[f].code === me.addSupportRequest.field) {
																				if (me.filterItems.fields[f].children !== null) {
																								for (var e = 0; e < me.filterItems.fields[f].children.length; e++) {
																									me.filterItems.branches.push(me.filterItems.fields[f].children[e]);
																						}
																						if (me.filterItems.branches.length > 0)	{
																						for (var b = 0; b <= me.filterItems.branches.length - 1; b++) {
																								if (me.filterItems.branches[b] !== undefined && me.filterItems.branches[b].code === me.addSupportRequest.branch) {
																								break;
																							}
																						}
																					}
																			}
																		}
																	}
																}
															}
															}
														}
													}
												}
											}
											}
										}
									}
							})
							.catch(function (err) {
                console.error(err);
            });
            }
          });
				} else {
            me.disableFlag = false;
						me.addSupportRequest.id = 0;
						me.addSupportRequest.addorupdateflag = true;
						me.addSupportRequest.officeName = null;
						me.addSupportRequest.officeId = null;
            me.addSupportRequest.userId = null;
            me.addSupportRequest.firstName = null;
            me.addSupportRequest.lastName = null;
						me.addSupportRequest.title = null;
						me.addSupportRequest.phone = null;
            me.addSupportRequest.email = null;
            me.addSupportRequest.contactPerson = "Elizabeth Walter";
            me.addSupportRequest.assignedTo = null;
            me.addSupportRequest.testedBy = "Elizabeth Walter";
            me.addSupportRequest.contactType = "";
            me.addSupportRequest.contactEmailCount = 0;
            me.addSupportRequest.contactPhoneCount = 0;
            me.addSupportRequest.contactOtherCount = 0;
						me.addSupportRequest.agency = null;
						me.addSupportRequest.program = null;
						me.addSupportRequest.field = null;
						me.addSupportRequest.branch = null;
						me.addSupportRequest.description = null;
						me.addSupportRequest.requestStatus = 1;
						me.addSupportRequest.topicType = "";
            me.heading = "Add New Support Request";
						me.message = "";
						officeManagementService.getAllSupportTopics().then(function (response) {
							me.addSupportRequest.problemTypes = [];
								if (response && response.data) {
									for (var i = 0; i < response.data.length; i++) {
										me.addSupportRequest.problemTypes.push(response.data[i]);
									}
								}
							}).catch(function (err) {
                console.error(err);
            });
					officeManagementService.getAllAgencyTrees().then(function (response) {
							me.filterItems.agencies = [];
							me.filterItems.programs = [];
							me.filterItems.fields = [];
							me.filterItems.branches = [];
								if (response && response.data.nodes) {
								for (var i = 0; i < response.data.nodes.length; i++) {
										me.filterItems.agencies.push(response.data.nodes[i]);
								}
								me.$refs['my-modal'].show();
							}
						})
						.catch(function (err) {
                console.error(err);
            });
          };
			},
		onChangeAgency (event) {
				const me = this;
				me.filterItems.programs = [];
				me.filterItems.fields = [];
				me.filterItems.branches = [];
				me.clear();
				for (var i = 0; i < me.filterItems.agencies.length; i++) {
					if (event.target.options[event.target.options.selectedIndex].value === me.filterItems.agencies[i].code) {
						me.addSupportRequest.department = me.filterItems.agencies[i].departmentName;
						me.addSupportRequest.officeName = me.filterItems.agencies[i].name;
						me.addSupportRequest.officeId = me.filterItems.agencies[i].id;
						me.addSupportRequest.userId = me.filterItems.agencies[i].code;
						me.getOfficeUsers(me.filterItems.agencies[i].id);
						for (var j = 0; j < me.filterItems.agencies[i].children.length; j++) {
								me.filterItems.programs.push(me.filterItems.agencies[i].children[j]);
						}
				}
			}
		},
		onChangeProgram (event) {
				const me = this;
				me.filterItems.fields = [];
				me.filterItems.branches = [];
				me.clear();
				for (var i = 0; i < me.filterItems.programs.length; i++) {
					if (event.target.options[event.target.options.selectedIndex].value === me.filterItems.programs[i].code) {
						me.addSupportRequest.department = me.filterItems.programs[i].departmentName;
						me.addSupportRequest.officeName = me.filterItems.programs[i].name;
						me.addSupportRequest.officeId = me.filterItems.programs[i].id;
						me.addSupportRequest.userId = me.addSupportRequest.agency + '-' + me.filterItems.programs[i].code;
						me.getOfficeUsers(me.filterItems.programs[i].id);
						if (me.filterItems.programs[i].children != null) {
						for (var j = 0; j < me.filterItems.programs[i].children.length; j++) {
								me.filterItems.fields.push(me.filterItems.programs[i].children[j]);
						}
					}
				}
			}
		},
		onChangeField (event) {
				const me = this;
				me.clear();
				me.filterItems.branches = [];
				for (var i = 0; i < me.filterItems.fields.length; i++) {
					if (event.target.options[event.target.options.selectedIndex].value === me.filterItems.fields[i].code) {
						me.addSupportRequest.department = me.filterItems.fields[i].departmentName;
						me.addSupportRequest.officeName = me.filterItems.fields[i].name;
						me.addSupportRequest.officeId = me.filterItems.fields[i].id;
						me.addSupportRequest.userId = me.addSupportRequest.agency + '-' + me.addSupportRequest.program + '-' + me.filterItems.fields[i].code;
						me.getOfficeUsers(me.filterItems.fields[i].id);
						for (var j = 0; j < me.filterItems.fields[i].children.length; j++) {
								me.filterItems.branches.push(me.filterItems.fields[i].children[j]);
					}
				}
			}
		},
		onChangeBranch (event) {
				const me = this;
				me.clear();
				for (var i = 0; i < me.filterItems.branches.length; i++) {
					if (event.target.options[event.target.options.selectedIndex].value === me.filterItems.branches[i].code) {
						me.addSupportRequest.department = me.filterItems.branches[i].departmentName;
						me.addSupportRequest.officeName = me.filterItems.branches[i].name;
						me.addSupportRequest.officeId = me.filterItems.branches[i].id;
						me.addSupportRequest.userId = me.addSupportRequest.agency + '-' + me.addSupportRequest.program + '-' + me.addSupportRequest.field + '-' + me.filterItems.branches[i].code;
						me.getOfficeUsers(me.filterItems.branches[i].id);
				}
			}
		},
		getOfficeUsers (officeId) {
				debugger;
				const me = this;
        userService.getUsersForOffice(officeId)
        .then(function (resp) {
          me.addSupportRequest.firstName = resp.data[0].nameFirst;
					me.addSupportRequest.lastName = resp.data[0].nameLast;
					me.addSupportRequest.email = resp.data[0].email;
					me.addSupportRequest.phone = resp.data[0].phone;
					me.addSupportRequest.title = resp.data[0].title;
        })
        .catch(function (err) {
            console.log(err);
            console.log("Error loading on the get office users.");
            throw err;
        });
    },
		clear () {
			const me = this;
			me.addSupportRequest.department = null;
			me.addSupportRequest.officeName = null;
			me.addSupportRequest.userId = null;
			me.addSupportRequest.firstName = null;
			me.addSupportRequest.lastName = null;
			me.addSupportRequest.title = null;
			me.addSupportRequest.phone = null;
			me.addSupportRequest.email = null;
		}
	}
};
</script>

<style scoped>
.search-ctrls {
  background-color: aliceblue;
  border: 1px solid #abc0e6;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 0 5px;
}
</style>
